const Style = {

  base: 'underline',
  defaultColor: 'text-blue-500',
  white: 'text-white',
  dark: 'text-slate-500',
  isBtn: "!text-black font-semibold mt-3 inline-block px-3 py-1 rounded-md border border-gray-300 hover:bg-gray-200 transition-colors duration-200 no-underline",

}

export default Style;